module.exports = __webpack_public_path__ + "static/media/podcast.2a4bf7be.svg";